module.exports = "/images/cart-add.svg";